import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { FaBars, FaTimes, FaWhatsapp } from 'react-icons/fa'; // Import WhatsApp, hamburger, and close icons

const Navbar = ({ toggleTheme, isDarkMode }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu
  const navigate = useNavigate(); // Get the navigate function from react-router-dom

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${searchQuery.trim()}`);
      setIsMenuOpen(false); // Close menu on search submit
    }
  };

  useEffect(() => {
    const body = document.body;
    // Update body class based on the isDarkMode prop
    if (isDarkMode) {
      body.classList.add('dark');
      body.classList.remove('light');
    } else {
      body.classList.add('light');
      body.classList.remove('dark');
    }
  }, [isDarkMode]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="200" height="60" viewBox="0 0 200 60">
            <g transform="translate(20, 30)">
              <circle cx="0" cy="0" r="15" fill="#FF6600" /> {/* Orange Gear */}
              <g id="gear">
                <circle cx="0" cy="0" r="10" fill="none" stroke="#fff" strokeWidth="2"/>
                <g fill="#FF6600"> {/* Orange gear details */}
                  <rect x="-1" y="-18" width="2" height="6" />
                  <rect x="-1" y="12" width="2" height="6" />
                  <rect x="12" y="-1" width="6" height="2" />
                  <rect x="-18" y="-1" width="6" height="2" />
                  <rect x="9" y="9" width="4" height="4" transform="rotate(45 11 11)" />
                  <rect x="-13" y="-13" width="4" height="4" transform="rotate(45 -11 -11)" />
                  <rect x="-13" y="9" width="4" height="4" transform="rotate(45 -11 11)" />
                  <rect x="9" y="-13" width="4" height="4" transform="rotate(45 11 -11)" />
                </g>
              </g>
            </g>
            <text x="35" y="40" fontFamily="Arial, sans-serif" fontSize="20" fill="#FF6600" letterSpacing="2">
              J Mechanisms
            </text>
            <animateTransform 
              xlinkHref="#gear" 
              attributeName="transform" 
              type="rotate" 
              from="0 0 0" 
              to="360 0 0" 
              dur="3s" 
              repeatCount="indefinite"
            />
          </svg>
      
        </Link>
  
        <button 
          className="hamburger" 
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />} {/* Hamburger icon */}
        </button>
        <ul className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/cars" onClick={closeMenu}>Vehicles</Link></li>
          <li><Link to="/bikes" onClick={closeMenu}>Bicycles</Link></li>
          <li><Link to="/terms" onClick={closeMenu}>Car Sourcing</Link></li>
          <li><Link to="/about" onClick={closeMenu}>About Us</Link></li>
          <li><Link to="/reviews" onClick={closeMenu}>Reviews</Link></li>
          <li><Link to="/contact" onClick={closeMenu}>Contact Us</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
